import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
import Multimedia from '../../../Multimedia';
import { StyledFigureFull } from '../../style';
// import { getCrop } from '../../../../../utils/crops';

const TemplateMultimediaFullScreen = ({ mediaType, src }) => (
  <StyledFigureFull>
    <Multimedia media={mediaType} src={src} />
  </StyledFigureFull>
);

TemplateMultimediaFullScreen.propTypes = {
  src: PropTypes.string,
  mediaType: PropTypes.string
};
export default compose(pure)(TemplateMultimediaFullScreen);
